export default "__VITE_ASSET__c21cf622__"